import React from 'react'

export default React.memo(function Separator({ field_value }) {
    return (
        <h5 className="custom-separators">{field_value}</h5>
    )
})
